import {
    Component,
    InputSignal,
    OnInit,
    Signal,
    computed,
    input,
    signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IqTrendlinesSocialStateService } from '../state';
import { CargoMdDirective } from '@dat/cargo-template';

@Component({
    selector: 'iq-trendlines-social-weekly-brief',
    standalone: true,
    imports: [CommonModule, CargoMdDirective],
    templateUrl: './iq-trendlines-social-weekly-brief.component.html',
    styleUrl: './iq-trendlines-social-weekly-brief.component.scss',
})
export class IqTrendlinesSocialWeeklyBriefComponent implements OnInit {
    id: InputSignal<string> = input('');
    testId: InputSignal<string> = input('');

    currentTestId: Signal<string> = computed(() => {
        return this.testId()?.length ? this.testId() : this.id();
    });

    briefTitleSignal: Signal<string> = signal('--');
    briefTitle: Signal<string> = computed((): string => {
        return this.briefTitleSignal();
    });

    // Call this in the OnInit Function
    private _setBriefTitleSignal(): void {
        this.briefTitleSignal = this._state.briefTitle();
    }

    briefDescriptionSignal: Signal<string> = signal('--');
    briefDescription: Signal<string> = computed((): string => {
        return this.briefDescriptionSignal();
    });

    // Call this in the OnInit Function
    private _setBriefDescriptionSignal(): void {
        this.briefDescriptionSignal = this._state.briefDescription();
    }

    constructor(private _state: IqTrendlinesSocialStateService) {}

    ngOnInit(): void {
        this._setBriefTitleSignal();
        this._setBriefDescriptionSignal();
    }
}
